export function excelFuelReportColumns() {
  const tyear = { key: 'tyear', header: 'År', width: 10 }
  const tmonth = { key: 'tmonth', header: 'Måned', width: 10 }
  const consolidatedInvoiceAgreement = { key: 'consolidatedInvoiceAgreement', header: 'Samlefaktura', width: 15 }
  const amountIncVAT = { key: 'amountIncVAT', header: 'Beløp inkl. MVA', width: 15 }
  const volume = { key: 'volume', header: 'Mengde', width: 15 }

  return [tyear, tmonth, consolidatedInvoiceAgreement, amountIncVAT, volume]
}

export function excelFuelReportDetailsColumns() {
  const regNo = { key: 'regNo', header: 'Regnr', width: 15 }
  const vehicleID = { key: 'vehicleID', header: 'Kjøretøy ID', width: 15 }
  const invoiceGroupingDescription = { key: 'invoiceGroupingDescription', header: 'Fakturagruppe', width: 25 }
  const carDescription = { key: 'carDescription', header: 'Objekt', width: 40 }
  const driverName = { key: 'driverName', header: 'Sjåfør', width: 20 }
  const amountincVAT = { key: 'amountincVAT', header: 'Beløp inkl. MVA', width: 15 }
  const volume = { key: 'volume', header: 'Mengde', width: 15 }
  const obsDescription = { key: 'obsDescription', header: 'Merknad', width: 30 }

  return [
    regNo,
    vehicleID,
    invoiceGroupingDescription,
    carDescription,
    driverName,
    amountincVAT,
    volume,
    obsDescription,
  ]
}

export function excelFuelReportExpenseDetailsColumns() {
  const transactionDate = { key: 'transactionDate', header: 'Dato', width: 15 }
  const transactionTime = { key: 'transactionTime', header: 'Tidspunkt', width: 15 }
  const referenceNo = { key: 'referenceNo', header: 'Kortnr.', width: 20 }
  const retailStationName = { key: 'retailStationName', header: 'Stasjon', width: 25 }
  const productDescription = { key: 'productDescription', header: 'Produkt', width: 20 }
  const amountincVAT = { key: 'amountincVAT', header: 'Beløp inkl. mva', width: 15 }
  const volume = { key: 'volume', header: 'Mengde', width: 15 }
  const paidCostperliter = { key: 'paidCostperliter', header: 'Pris p/enhet', width: 15 }
  const regKm = { key: 'regKm', header: 'Kilometerstand', width: 15 }
  const obs = { key: 'obs', header: 'Merknad', width: 20 }

  return [
    transactionDate,
    transactionTime,
    referenceNo,
    retailStationName,
    productDescription,
    amountincVAT,
    volume,
    paidCostperliter,
    regKm,
    obs,
  ]
}
